import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopApi from '../generated/api/Shop';

export default (service: Servicelayer) => ({
  ...ShopApi(service),

  // Add custom calls here

});
